import React, { useState } from "react";
import { PlatformLayout } from "./PlatformLayout";
import { JoinContent } from "./join/JoinContent";
import JoinModal from "./join/JoinModal";
import JoinFinalCTA from "./join/JoinFinalCTA";
import Ecosystem from "./Ecosystem";

export default function JoinNetwork() {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const referrerCode = (typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("ref") : "") || "";
  return (
    <PlatformLayout searchDock={false} glassHeader preFooterCTA={false}>
      <div className="bg-[#050505] min-h-screen text-white platform-scope" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="join-network-page">
        <JoinContent coverImage="https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/1e5c2baedcc2d0a1a29b83f22ade14d304df4cc7cad2698eb6bf8b1621696e8f.jpeg" ctaImage="https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/58c361441054242fc19bac63dd12f3c634352af74b086e5fcaf94171313a6b20.jpeg" onJoin={(t) => { setType(t || ""); setOpen(true); }} />
        <Ecosystem />
        <JoinFinalCTA ctaImage="https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/58c361441054242fc19bac63dd12f3c634352af74b086e5fcaf94171313a6b20.jpeg" onJoin={() => { setType(""); setOpen(true); }} />
      </div>
      <JoinModal open={open} onClose={() => setOpen(false)} defaultType={type} referrerCode={referrerCode} />
    </PlatformLayout>
  );
}
